import { render, staticRenderFns } from "./CreditImpairment.vue?vue&type=template&id=da18e7ba&scoped=true"
import script from "./CreditImpairment.vue?vue&type=script&lang=js"
export * from "./CreditImpairment.vue?vue&type=script&lang=js"
import style0 from "./CreditImpairment.vue?vue&type=style&index=0&id=da18e7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da18e7ba",
  null
  
)

export default component.exports